import { useEffect, useState } from 'react'
import { Button, Label } from 'reactstrap'
import './TableFilter.css'

// How To Use
// filterTypes => [
//     {key: "apiKey", type: "text|date|number|select", hide: "boolean", options: [
//         {label: "", value: ""}
//     ]}
// ]

const formatText = (txt) => txt.replace("_", " ")

const TableFilter = ({filterTypes, onFilter}) => {
    const [filters, setFilters] = useState({})

    useEffect(() => {
        filterTypes.map(f => {
            if(f.initial) {
                setFilters(prev => ({...prev, [f.key]: f.initial}))
            }
        })
    }, [])

    return (
        <div className='mb-4 d-flex align-items-center flex-wrap table-filter'>
            {filterTypes && filterTypes.filter(f => f.hide != true).map((item, idx) => (
                <div className="d-flex align-items-center mb-2 me-3" key={idx}>
                    <Label className="mb-0 me-2 text-nowrap">
                        {item.label ? item.label : formatText(item.key)}
                    </Label>
                    {item.type === 'select' ? (
                        <select
                            onChange={(e) => setFilters(f => ({...f, [item.key]: e.target.value !== "all" ? e.target.value : null}))}
                            className="form-control"
                            style={{minWidth: filterTypes.filter(f => f.hide != true).length < 3 ? '200px' : '110px'}}
                        >
                            {item.options.map(op => <option key={op.value} value={op.value}>{op.label}</option>)}
                        </select>
                    ) : (
                        <input
                            type={item.type || "text"}
                            onChange={(e) => setFilters(f => ({...f, [item.key]: e.target.value}))}
                            placeholder={`Enter ${formatText(item.key)}...`}
                            className="form-control"
                            value={filters[item.key]}
                        />
                    )}
                </div>
            ))}
                <div className='mb-2'>
                    <Button color="primary" onClick={() => onFilter(filters)}>Filter</Button>
                </div>
        </div>
    )
}

export default TableFilter